import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { AccountAssessment } from '../../../models/AssessmentModel';
import { AssessmentService } from '../../../services/assessment.service';

@Component({
  selector: 'app-risk-selector',
  templateUrl: './risk-selector.component.html',
  styleUrls: ['./risk-selector.component.scss']
})
export class RiskSelectorComponent implements OnInit {
  _assessment: AccountAssessment;
  selectedNistFunction: string;
  nistFunctions: Array<string> = [];

  get assessment(): AccountAssessment { return this._assessment; }

  @Input()
  set assessment(assessment: AccountAssessment) {
    this._assessment = assessment;
    this.nistFunctions = Object.keys(this._assessment.scoredResultsJson.nistFunctions);
  }

  @Output() nistFunctionSelector: EventEmitter<any> = new EventEmitter();

  constructor(public assessmentService: AssessmentService) { }

  ngOnInit() {
  }

  getOverallRisk() {
    return this.assessmentService.getRiskLabel(this._assessment.scoredResultsJson);
  }

  selectNistFunction(nistFunction) {
    if (this.selectedNistFunction == nistFunction) {
      this.selectedNistFunction = undefined;
    } else {
      this.selectedNistFunction = nistFunction;
    }
    this.nistFunctionSelector.emit({ selectedNistFunction: this.selectedNistFunction });
  }

  getNistFunctionRisk(nistFunction: string): string {
    return this.assessmentService.getRiskLabel(this._assessment.scoredResultsJson.nistFunctions[nistFunction]);
  }

  getNistFunctionRiskColorByLabel(riskLabel: string): string {
    return this.assessmentService.getRiskColorByLabel(riskLabel);
  }

  getNistFunctionScore(nistFunction: string): number {
    return Math.round(this._assessment.scoredResultsJson.nistFunctions[nistFunction].score);
  }

  getNistFunctionText(nistFunction: string): string {
    const text = this._assessment.scoredResultsJson.nistFunctions[nistFunction].name.toLowerCase();
    return text.charAt(0).toUpperCase() + text.substr(1);
  }

  getNistFunctionCount() {
    if (this.nistFunctions && this.nistFunctions.length > 0) {
      return this.nistFunctions.length;
    } else {
      return 1;
    }
  }

  getSelectedStyle(nistSection) {
    if (nistSection == this.selectedNistFunction) {
      return {
        color: this.getNistFunctionColor(nistSection).contrast,
        'background-color': `rgb(${this.getNistFunctionColor(nistSection).rgb})`
      }
    }
  }

  getNistFunctionColor(nistFunction) {
    const color = {
      contrast: '#000',
      rgb: '255, 255, 255'
    };
    if (this.selectedNistFunction == nistFunction) {
      return this.assessmentService.getNistFunctionColor(nistFunction);
    } else {
      return color;
    }
  }

  scoreLabel(value: number): string {
    return `${Math.round(value)}`;
  }

  scoreDialClass(): string {
    if (this._assessment.scoredResultsJson.score < 50) {
      return 'low-score';
    } else if (this._assessment.scoredResultsJson.score < 80) {
      return 'medium-score';
    } else {
      return 'high-score';
    }
  }
}
